// extracted by mini-css-extract-plugin
export default {"primaryColor":"#dd2f2f","primaryColorWithAlpha":"rgba(238,233,233,.9176470588)","mainBgColor":"#f5f5f5","secondBgColor":"#fff","menuTextColor":"#29292c"};